import {Fetcher} from "./fetcher.ts";
import {Album} from "../models/db/tri/Album.ts";
import {Track} from "../models/db/tri/Track.ts";
import {SearchResult} from "../models/SearchResult.ts";
import {SubmissionRequest} from "../models/SubmissionRequest.ts";
import {Artist} from "../models/db/tri/Artist.ts";

const base = window.location.origin.includes("localhost") ? "http://localhost:8090" : "https://artists-api.trirecords.eu";

export class Api {
    static baseUrl = base;

    static async getAlbums() {
        return await Fetcher.get<Album[]>(base + "/albums/get?onlyReleased=true");
    }

    static async getAlbum(id: number) {
        return await Fetcher.get<Album>(base + "/albums/byId?id=" + id);
    }

    static getTrack(id: number) {
        return Fetcher.get<Track>(base + "/tracks/byId?id=" + id);
    }

    static async getTracks() {
        return await Fetcher.get<Track[]>(base + "/tracks/get?onlyReleased=true");
    }

    static searchTracks(q: string) {
        return Fetcher.get<SearchResult[]>(base + "/search/tracks?search=" + q);
    }

    static searchAlbums(q: string) {
        return Fetcher.get<SearchResult[]>(base + "/search/albums?search=" + q);
    }

    static submitRelease(param: SubmissionRequest) {
        return Fetcher.post(base + "/submissions/create", param);
    }

    static getArtists() {
        return Fetcher.get<Artist[]>(base + "/artists/get");
    }

    static async getArtist(name: string) {
        return await Fetcher.get<Artist>(base + "/artists/byName?name=" + name);
    }
}